module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid full-height d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), (_vm.messageType == 'SUCCESS') ? _c('div', {
    staticClass: "message-banner-success"
  }, [_c('span', {
    staticClass: "message-text",
    domProps: {
      "innerHTML": _vm._s(_vm.messageText)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close-button",
    attrs: {
      "onclick": "closeBanner()"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.messageType == 'ERROR') ? _c('div', {
    staticClass: "message-banner-error"
  }, [_c('span', {
    staticClass: "message-text",
    domProps: {
      "innerHTML": _vm._s(_vm.messageText)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close-button",
    attrs: {
      "onclick": "closeBanner()"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "id": "passCode",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnterPassCode($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "150px"
    }
  }), _vm._v(" "), (_vm.viewType == 'CHECK-IN') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "250px",
      "height": "180px",
      "font-size": "40px",
      "font-weight": "bold"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCheckIn
    }
  }, [_vm._v("CHECK-IN")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e8c9a88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ManualCheckInOut.vue
// module id = 809
// module chunks = 1